import { render, staticRenderFns } from "./StockRappMenu.vue?vue&type=template&id=3395ad84&scoped=true&"
import script from "./StockRappMenu.vue?vue&type=script&lang=js&"
export * from "./StockRappMenu.vue?vue&type=script&lang=js&"
import style0 from "./StockRappMenu.vue?vue&type=style&index=0&id=3395ad84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3395ad84",
  null
  
)

export default component.exports